export const isAEC = document.location.href.indexOf('aec-ecurie.fr') !== -1;
